<template lang="pug">
    .sidebar__tabs-item(v-bind:class="name")
        .sidebar__header(v-bind:class="`${name}__header`")
            slot(name="header")

        .sidebar__container(
            v-bind:class="`${name}__container`"
            v-bar="true"
        )
            .sidebar__scroll-container(
                v-bind:class="`${name}__scroll-container`"
            )
                slot(name="container")
        slot

</template>

<script>
export default {
    props: {
        name: {
            type: String,
            default: '',
            required: true
        }
    }
};
</script>
